import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';
import { useTenants } from '@/services/tenants/useTenants';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import { Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const AdvancedAnalysisButton = ({ assetId, className }: { assetId: string; className?: string }) => {
  const { getPath } = useTenants();
  return (
    <Link to={getPath(`analysis/${assetId}`)}>
      <Button
        startIcon={<AnalyticsIcon />}
        className={className}
        data-testid={AssetPageObjectModel.AdvancedAnalysisButton}
      >
        Advanced analysis
      </Button>
    </Link>
  );
};
